<template>
  <div class="user-center">
    <app-header
      class="navi"
      title="会员中心"
      :transparent="true"
      :bgcolor="mybgcolor"
      back-type="back-app"
      ref="vipheader"
    />
    <UserCenterHeader class="userhead" :info="info" :membership="membership" @renew="renewVip"></UserCenterHeader>
    <PrivilegePanel :title="rowTitle[0]" :list="rowList[0]"></PrivilegePanel>
  </div>
</template>

<script>
import PrivilegePanel from './PrivilegePanel'
import UserCenterHeader from './UserCenterHeader'
import service from '@/api/modules/user'
import { $settingBounces } from '@/utils/common/native-api'

export default {
  name: 'VipCenter',
  data: function () {
    return {
      info: {},
      membership: [],
      showBar: false,
      mybgcolor: '#0000',
      rowTitle: ['专属特权', '特色功能', '专属客服'],
      rowList: [
        [
          {
            subtitle: '购买当年已上架专辑永久免费畅听',
            title: '永久免费畅听',
            icon: require('../../images/ucenter/section0_0.png')
          },
          // {
          //   subtitle: '专享学习社群',
          //   icon: require('../../images/ucenter/section0_4.png')
          // },
          {
            title: '1元增订福利',
            subtitle: '每年上新全部课程支付1元/年即可永久免费畅听',
            icon: require('../../images/ucenter/section0_5.png')
          }
          //  {
          //   title: '专属班主任',
          //   subtitle: '给予学习建议,各类活动通知等',
          //   icon: require('../../images/ucenter/section1_3.png')
          // }
        ]
      ]
    }
  },
  components: {
    PrivilegePanel,
    UserCenterHeader
  },
  methods: {
    // 增订 VIP
    renewVip() {
      if (this.membership.length <= 0) {
        return console.log('v1/user/myinfo/my----->membership为0')
      }
      // "goodsId":91934, 主商品 ID
      // "renewalGoodsId": 91938, 续订商品 ID
      // "renewalLink":https://new-wx.ylyk.com/test/ylyk/payment.html?shareCode=Z29vZHNJZD05MTkzOA==#/goods
      const obj = this.membership[0]
      const goodsId = obj.renewalGoodsId
      if (goodsId === undefined) {
        return
      }
      // 通过路由,跳转到商品详情页
      // 'paytype' 值无意义,只是为了让 goods 页面的 backbtn,执行 goBack 而不是 $backToAppCallBack
      this.$router.push({
        path: '/goods',
        query: { goodsId: goodsId.toString(), paytype: '1' }
      })
    },
    getUserInfo() {
      service.getUserDetail().then(res => {
        this.info = res
      })
    },
    getActiveState() {
      service.getAccountState().then(res => {
        this.membership = res.membership
      })
    },
    handleScroll() {
      const yOffset = window.pageYOffset
      if (yOffset <= 40) {
        const alpha = yOffset / 40
        this.mybgcolor = `rgba(255,255,255,${alpha})`

        const color = `rgba(0,0,0,${alpha})`
        if (yOffset <= 2) {
          this.$refs.vipheader.$refs.appheader.$el.style.color = '#fff'
        } else {
          this.$refs.vipheader.$refs.appheader.$el.style.color = color
        }
        this.showBar = false
      } else {
        // 显示导航条,白底黑字
        if (!this.showBar) {
          this.mybgcolor = '#fff'
          this.$refs.vipheader.$refs.appheader.$el.style.color = '#000'
          this.showBar = true
        }
      }
    },
    handleOrientation() {
      const { style, clientWidth, clientHeight } = document.documentElement
      if (window.orientation === 180 || window.orientation === 0) {
        // 竖屏
        style.fontSize = Math.min(clientWidth, clientHeight) / 7.5 + 'px'
      }
      if (window.orientation === 90 || window.orientation === -90) {
        // 横屏
        style.fontSize = Math.max(clientWidth, clientHeight) / 7.5 + 'px'
      }
    }
  },
  created() {
    $settingBounces({
      bounces: 'disenable'
    })
    this.getUserInfo()
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true)
    window.addEventListener(
      'onorientationchange' in window ? 'orientationchange' : 'resize',
      this.handleOrientation,
      false
    )
  },
  activated() {
    this.getActiveState()
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener(
      'onorientationchange' in window ? 'orientationchange' : 'resize',
      this.handleOrientation,
      false
    )
  }
}
</script>

<style lang="scss" scoped>
.user-center {
  .navi {
    position: absolute;
    top: 0;
  }
  .userhead {
    position: relative;
    width: 100%;
    height: 5.32rem;
    background: linear-gradient(227deg, #cdd1da, #969ba7 100%);
  }
}
</style>
